import React from 'react';
import AccordionArrow from '../../Basic/Icons/AccordionArrow.mjs';
import VerticalList from '../../Basic/Lists/VerticalList/VerticalList.mjs';
import Heading from '../../Typography/Heading/Heading.mjs';
import { StyledAccordionHeading, StyledAccordionBody } from './VerticalAccordion.styles.mjs';

const VerticalAccordion = ({ options, heading, isOpen, onClick, onOptionClick }) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledAccordionHeading, { onClick: onClick, isOpen: isOpen },
            React.createElement(Heading, { tag: "h3" }, heading),
            React.createElement(AccordionArrow, null)),
        React.createElement(StyledAccordionBody, { isOpen: isOpen },
            React.createElement(VerticalList, { options: options, onClick: onOptionClick }))));
};

export { VerticalAccordion as default };
//# sourceMappingURL=VerticalAccordion.mjs.map
